import type { SITE_WORKING_CONDITION_ACQUISITION_CARD_FRENCH_LOCALE } from "~ui/@application/locales/modules/components/site-working-condition-acquisition-card/site-working-condition-acquisition-card.fr.ts";

export const SITE_WORKING_CONDITION_ACQUISITION_CARD_ENGLISH_LOCALE = {
  title: "Acquisition",
  lastSevenDays: "Last 7 days",
  tabs: {
    modulators: "Modulators",
    pilots: "Pilots",
    sensors: "Third party sensors",
  },
} satisfies typeof SITE_WORKING_CONDITION_ACQUISITION_CARD_FRENCH_LOCALE;
